export default __webpack_public_path__ + "1.17.19/static/media/info-icon.c45feb7c.svg";